import {QuotaSelectorItem} from "@/components/QuotaItemSelector";
import {UNLIMITED} from "@/constants";
import {defineMessages, FormattedMessage, MessageDescriptor} from "react-intl";
import {makeStyles} from "tss-react/mui";
import {UserPackageAllocationInfo} from "../create/DataSource";
import {errorToErrorWithContext} from "@/tools";
import {DomainAllocationInfoWithName} from "@/api";
import {FC} from "react";

export const useLimitTableStyles = makeStyles()(() => ({
    limitTable: {
        textAlign: "right",
        paddingRight: "0.2em",
        "& th": {
            padding: "0px 10px",
            textAlign: "center",
            cursor: "default",
        },
        "& td": {
            padding: "0px 10px",
            textAlign: "center",
            cursor: "default",
        },
        "& th:first-of-type": {
            textAlign: "left",
        },
        "& td:first-of-type": {
            textAlign: "left",
        },
        /*
        '& th+th': {
            borderLeft: "1px solid black",
            borderColor: "rgba(0, 0, 0, .2)",
        },*/
        "& td+td": {
            borderLeft: "1px solid black",
            borderColor: "rgba(0, 0, 0, .2)",
        },
    },
}));

export const NoValidSet = ({msgDesc}: {msgDesc: MessageDescriptor}) => (
    <div style={{marginTop: 11, opacity: 0.7, fontStyle: "italic"}}>
        <FormattedMessage {...msgDesc} />
    </div>
);

export const format_quota = (quota: number | undefined | null) =>
    quota == null || quota === UNLIMITED ? <FormattedMessage id="unlimited" defaultMessage="Unlimited" /> : quota;

export const domainAllocationInfoToQuotaItem = (
    allocation: Partial<Omit<DomainAllocationInfoWithName, "__typename">>,
    name?: string,
): QuotaSelectorItem => ({
    value: name ?? allocation.name,
    allocationIncrementError: errorToErrorWithContext(allocation.allocationIncrementError),
    domainUsed: allocation.domainUsed,
    domainAllocated: allocation.domainAllocated,
});

export const userPackageAllocationToQuotaItem = (allocation: UserPackageAllocationInfo): QuotaSelectorItem => ({
    value: allocation.name,
    allocationIncrementError: errorToErrorWithContext(allocation.allocationIncrementError),
    domainUsed: allocation.domainUsed,
    domainAllocated: allocation.domainAllocated,
});

export const extensionLimitTranslations = {
    headers: defineMessages({
        devices: {
            id: "extensionQuotaSettings.headers.devices",
            defaultMessage: "Devices",
        },
        capability: {
            id: "extensionQuotaSettings.headers.capability",
            defaultMessage: "Capability",
        },
        used: {
            id: "extensionQuotaSettings.headers.used",
            defaultMessage: "Used",
        },
        allowed: {
            id: "extensionQuotaSettings.headers.allowed",
            defaultMessage: "Allowed",
        },
        fromUp: {
            id: "extensionQuotaSettings.headers.from_up",
            defaultMessage: "From User Package",
        },
        available: {
            id: "extensionQuotaSettings.headers.available",
            defaultMessage: "Total Available",
        },
        domain: {
            id: "extensionQuotaSettings.headers.domain",
            defaultMessage: "Domain (used / allocated)",
        },
        system: {
            id: "extensionQuotaSettings.headers.system",
            defaultMessage: "System (used / limit)",
        },
    }),
} as const;

export const FormattedExtensionLimitTableHeader: FC<{
    header: keyof (typeof extensionLimitTranslations)["headers"];
}> = ({header}) => {
    return (
        <th>
            <FormattedMessage {...extensionLimitTranslations["headers"][header]} />
        </th>
    );
};
